module.exports = __webpack_public_path__ + "img/Desk Stationary A03.629ca74a.jpg";